export default "__VITE_ASSET__pLeatrMS__"